(function () {
    'use strict';
    
    
    var env = {};
    if(window){  
        Object.assign(env, window._env);
    }
    
    angular
        .module('assets.mybimiboo.com', [
            'ui.router', 'ngSanitize', 'templates', 'bw.paging', 'schemaForm', 'ui.ace', 'treeControl', 'ui.sortable'
        ])
        .constant('_env', env)
        .config(httpProviderConfig)
        .config(routeProviderConfig)
        .run(run);
    
    function httpProviderConfig($httpProvider) {
        $httpProvider.interceptors.push(function($q) {
            return {
                'responseError': function(rejection) {
                    var defer = $q.defer();
                    if(rejection.status == 401) {
                        window.location.assign('#/login');
                    }
                    defer.reject(rejection);

                    return defer.promise;
                },
                'request': function(config) {
                    config.headers = config.headers || {};
                    if (localStorage.getItem('token')) {
                        config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
                    }
                    return config || $q.when(config);
                }
            };
        });
    }

    function routeProviderConfig($stateProvider, $urlRouterProvider) {
        
        // $urlRouterProvider
        //     .when('', '/locations')
        //     .otherwise('/locations');

        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'templates/login/view.html',
                controller: 'LoginCtrl',
                restrictions: {
                    ensureAuthenticated: false,
                    loginRedirect: true
                }
            })
            .state('home', {
                url: '',
                templateUrl: 'templates/home/view.html',
                controller: 'HomeCtrl',
                restrictions: {
                    ensureAuthenticated: false,
                    loginRedirect: false
                }
            })
            .state('home.organizations', {
                url: '/organizations',
                templateUrl: 'templates/organizations/list/view.html',
                controller: 'OrganizationsCtrl',
                restrictions: {
                    ensureAuthenticated: false,
                    loginRedirect: false
                }
            })
            .state('home.organization', {
                url: '/organization/:id',
                templateUrl: 'templates/organizations/details/view.html',
                controller: 'OrganizationCtrl',
                restrictions: {
                    ensureAuthenticated: false,
                    loginRedirect: false
                }
            })
            .state('home.categories', {
                url: '/categories',
                templateUrl: 'templates/categories/view.html',
                controller: 'CategoriesCtrl',
                restrictions: {
                    ensureAuthenticated: false,
                    loginRedirect: false
                }
            })
            .state('home.employees', {
                url: '/employees',
                templateUrl: 'templates/employees/view.html',
                controller: 'EmployeeCtrl',
                restrictions: {
                    ensureAuthenticated: false,
                    loginRedirect: false
                }
            })
            .state('home.users', {
                url: '/users',
                templateUrl: 'templates/users/view.html',
                controller: 'UsersCtrl',
                restrictions: {
                    ensureAuthenticated: false,
                    loginRedirect: false
                }
            });

    }

    function run($rootScope, $timeout) {

        $rootScope.formatDate = formatDate;

        $rootScope.$on('$routeChangeStart', function(event, next, current) {

            if (next.restrictions.ensureAuthenticated) {
                if (!localStorage.getItem('token')) {
                    $location.path('/login');
                }
            }

            if (next.restrictions.loginRedirect) {
                if (localStorage.getItem('token')) {
                    $location.path('/home');
                }
            }

        });

        $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                // fix sidebar
                var neg = $('.main-header').outerHeight() + $('.main-footer').outerHeight()
                var window_height = $(window).height()
                var sidebar_height = $('.sidebar').height()

                if ($('body').hasClass('fixed')) {
                    $('.content-wrapper, .right-side').css('min-height', window_height - $('.main-footer').outerHeight())
                } else {
                    if (window_height >= sidebar_height) {
                        $('.content-wrapper, .right-side').css('min-height', window_height - neg)
                    } else {
                        $('.content-wrapper, .right-side').css('min-height', sidebar_height)
                    }
                }
            })
        })
    }
    
})();
